/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetCommonState200ResponseDataMktuInner } from './GetCommonState200ResponseDataMktuInner'
import {
  GetCommonState200ResponseDataMktuInnerFromJSON,
  GetCommonState200ResponseDataMktuInnerFromJSONTyped,
  GetCommonState200ResponseDataMktuInnerToJSON,
} from './GetCommonState200ResponseDataMktuInner'
import type { ApplicationStage } from './ApplicationStage'
import {
  ApplicationStageFromJSON,
  ApplicationStageFromJSONTyped,
  ApplicationStageToJSON,
} from './ApplicationStage'
import type { Product } from './Product'
import { ProductFromJSON, ProductFromJSONTyped, ProductToJSON } from './Product'
import type { Applicant } from './Applicant'
import {
  ApplicantFromJSON,
  ApplicantFromJSONTyped,
  ApplicantToJSON,
} from './Applicant'

/**
 *
 * @export
 * @interface GetCommonState200ResponseData
 */
export interface GetCommonState200ResponseData {
  /**
   * Порядковый номер заявки
   * @type {number}
   * @memberof GetCommonState200ResponseData
   */
  applicationNumber: number
  /**
   * Последний пройденный этап
   * @type {ApplicationStage}
   * @memberof GetCommonState200ResponseData
   */
  lastStage: ApplicationStage | null
  /**
   * Текущий (следующий) этап
   * @type {ApplicationStage}
   * @memberof GetCommonState200ResponseData
   */
  currentStage: ApplicationStage
  /**
   * Ссылка на изображение знака
   * @type {string}
   * @memberof GetCommonState200ResponseData
   */
  applicationImageUrl: string | null
  /**
   * Статистика выбранных классов МКТУ
   * @type {Array<GetCommonState200ResponseDataMktuInner>}
   * @memberof GetCommonState200ResponseData
   */
  mktu: Array<GetCommonState200ResponseDataMktuInner>
  /**
   * Правообладатель заявки
   * @type {Applicant}
   * @memberof GetCommonState200ResponseData
   */
  applicant: Applicant
  /**
   * Услуги из неоплаченного ордера (пустой массив, если ордера нет)
   * @type {Array<Product>}
   * @memberof GetCommonState200ResponseData
   */
  products: Array<Product>
  /**
   * Заявку можно удалить (нет оплаченных ордеров)
   * @type {boolean}
   * @memberof GetCommonState200ResponseData
   */
  canBeDeleted: boolean
  /**
   * Ссылка на редактирование в Filament-админке; поле присутствует только для админских аккаунтов
   * @type {string}
   * @memberof GetCommonState200ResponseData
   */
  linkInAdmin?: string
}

/**
 * Check if a given object implements the GetCommonState200ResponseData interface.
 */
export function instanceOfGetCommonState200ResponseData(
  value: object
): value is GetCommonState200ResponseData {
  if (
    !('applicationNumber' in value) ||
    value['applicationNumber'] === undefined
  )
    return false
  if (!('lastStage' in value) || value['lastStage'] === undefined) return false
  if (!('currentStage' in value) || value['currentStage'] === undefined)
    return false
  if (
    !('applicationImageUrl' in value) ||
    value['applicationImageUrl'] === undefined
  )
    return false
  if (!('mktu' in value) || value['mktu'] === undefined) return false
  if (!('applicant' in value) || value['applicant'] === undefined) return false
  if (!('products' in value) || value['products'] === undefined) return false
  if (!('canBeDeleted' in value) || value['canBeDeleted'] === undefined)
    return false
  return true
}

export function GetCommonState200ResponseDataFromJSON(
  json: any
): GetCommonState200ResponseData {
  return GetCommonState200ResponseDataFromJSONTyped(json, false)
}

export function GetCommonState200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCommonState200ResponseData {
  if (json == null) {
    return json
  }
  return {
    applicationNumber: json['applicationNumber'],
    lastStage: ApplicationStageFromJSON(json['lastStage']),
    currentStage: ApplicationStageFromJSON(json['currentStage']),
    applicationImageUrl: json['applicationImageUrl'],
    mktu: (json['mktu'] as Array<any>).map(
      GetCommonState200ResponseDataMktuInnerFromJSON
    ),
    applicant: ApplicantFromJSON(json['applicant']),
    products: (json['products'] as Array<any>).map(ProductFromJSON),
    canBeDeleted: json['canBeDeleted'],
    linkInAdmin: json['linkInAdmin'] == null ? undefined : json['linkInAdmin'],
  }
}

export function GetCommonState200ResponseDataToJSON(
  value?: GetCommonState200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    applicationNumber: value['applicationNumber'],
    lastStage: ApplicationStageToJSON(value['lastStage']),
    currentStage: ApplicationStageToJSON(value['currentStage']),
    applicationImageUrl: value['applicationImageUrl'],
    mktu: (value['mktu'] as Array<any>).map(
      GetCommonState200ResponseDataMktuInnerToJSON
    ),
    applicant: ApplicantToJSON(value['applicant']),
    products: (value['products'] as Array<any>).map(ProductToJSON),
    canBeDeleted: value['canBeDeleted'],
    linkInAdmin: value['linkInAdmin'],
  }
}
